import React from "react";
import { observer } from "mobx-react-lite";
import { useStore } from "../Store";
import { ReactComponent as Audi } from "./Resources/Img/Logos/audi.svg";
import { ReactComponent as Bmw } from "./Resources/Img/Logos/bmw.svg";
import { ReactComponent as Cupra } from "./Resources/Img/Logos/cupra.svg";
import { ReactComponent as Jaguar } from "./Resources/Img/Logos/jaguar.svg";
import { ReactComponent as Kia } from "./Resources/Img/Logos/kia.svg";
import { ReactComponent as KiaAssistans } from "./Resources/Img/Logos/kia-assistans.svg";
import { ReactComponent as MazdaInsurance } from "./Resources/Img/Logos/mazda-insurance.svg";
import { ReactComponent as Mg } from "./Resources/Img/Logos/mg.svg";
import { ReactComponent as Nissan } from "./Resources/Img/Logos/nissan.svg";
import { ReactComponent as Porsche } from "./Resources/Img/Logos/porsche.svg";
import { ReactComponent as Seat } from "./Resources/Img/Logos/seat.svg";
import { ReactComponent as Skoda } from "./Resources/Img/Logos/skoda.svg";
import { ReactComponent as Ssangyong } from "./Resources/Img/Logos/ssangyong.svg";
import { ReactComponent as VolkswagenAssistance } from "./Resources/Img/Logos/volkswagen-assistance.svg";
import { ReactComponent as VolkswagenInsurance } from "./Resources/Img/Logos/volkswagen-insurance.svg";
import { ReactComponent as Volvia } from "./Resources/Img/Logos/volvia.svg";

const logos: Record<string, React.FunctionComponent<React.SVGProps<SVGSVGElement>>> = {
  audi: Audi,
  bmw: Bmw,
  cupra: Cupra,
  jaguar: Jaguar,
  kia: Kia,
  "kia-assistans": KiaAssistans,
  "mazda-insurance": MazdaInsurance,
  mg: Mg,
  nissan: Nissan,
  porsche: Porsche,
  seat: Seat,
  skoda: Skoda,
  ssangyong: Ssangyong,
  "volkswagen-assistance": VolkswagenAssistance,
  "volkswagen-insurance": VolkswagenInsurance,
  volvia: Volvia,
};

const backgroundLogos = new Set([
  "if-assistance", "if-assistans", "subaru", "subaru-assistans",
  "kamux", "citroen", "mazda-assistance", "peugeot", "rulla-vidare",
  "chevrolet", "volvia-commercial", "mercedes", "mini", "ford",
  "land-rover", "hongqi", "hedin", "polestar",
]);

const LogoModel = () => {
  const { casesStore } = useStore();
  const brand = casesStore.brand;
  const Logo = logos[brand];

  return (
    <div className={`header-logo-first-${brand}`}>
      {Logo ? <Logo role="img" aria-label={brand} /> :
        backgroundLogos.has(brand) ? null : <span>{brand.replace(/-/g, " ")}</span>}
    </div>
  );
};

export default observer(LogoModel);
